"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.model = void 0;
const dataloader_1 = __importDefault(require("dataloader"));
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const create_model_1 = require("./create-model");
const model_error_1 = require("./model-error");
const value_1 = require("./value");
function model(fetcher, config = {}) {
    const loaders = {};
    return create_model_1.createModel(Object.assign(Object.assign({}, config), { read(query, context) {
            var _a;
            return (_a = context.cache.getData(query)) !== null && _a !== void 0 ? _a : context.cache.getError(query);
        },
        load(query, context) {
            let aborted = false;
            const fetchContext = {
                batch: (_config) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    const config = typeof _config === "function" ? { getBatch: _config } : _config;
                    const key = config.key == null ? "default" : fast_json_stable_stringify_1.default(config.key);
                    if (!loaders[key]) {
                        loaders[key] = new dataloader_1.default(config.getBatch, {
                            cache: false,
                            maxBatchSize: (_a = config.maxBatchSize) !== null && _a !== void 0 ? _a : 50,
                        });
                    }
                    return loaders[key].load(query.params);
                }),
                previous: context.cache.getData(query),
            };
            fetcher(query.params, fetchContext).then((data) => {
                if (aborted)
                    return;
                context.cache.set(query, value_1.DataValue(data));
            }, (error) => {
                if (aborted)
                    return;
                context.cache.set(query, value_1.ErrorValue(model_error_1.ModelError.from(error)));
            });
            return () => {
                aborted = true;
            };
        },
        write(query, dataOrError, context) {
            context.cache.set(query, dataOrError instanceof Error
                ? value_1.ErrorValue(model_error_1.ModelError.from(dataOrError))
                : value_1.DataValue(dataOrError));
        },
        invalidate(query, context) {
            context.cache.delete(query);
        } }));
}
exports.model = model;
